import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {AppointmentTitleRestService} from '../../services/appointment/appointment-title-rest.service';
import {StandardTitle} from '../../types/appointment/standard-title';

@Component({
  selector: 'wsd-select-standard-title',
  templateUrl: './select-standard-title.component.html',
  styleUrls: ['./select-standard-title.component.css']
})
export class SelectStandardTitleComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_STANDARD_TITLE.LABEL';

  @Input()
  placeholder: string = 'SELECT_STANDARD_TITLE.PLACEHOLDER';

  @Input()
  controlName: string = 'standardTitle';

  @Input()
  showLabel: boolean = true;

  @Input()
  showPlaceholder: boolean = true;

  @Output()
  onSelect: EventEmitter<StandardTitle> = new EventEmitter();

  standardTitleItems: SelectItem[] = [];

  constructor(private appointmentTitleRestService: AppointmentTitleRestService) { }

  ngOnInit() {
    this.loadTitles();
  }

  private loadTitles() {
    this.appointmentTitleRestService.getStandardTitles().subscribe(
      (titles: StandardTitle[]) => {
        this.fillTitles(titles);
      }
    );
  }

  private fillTitles(titles: StandardTitle[]) {
    this.standardTitleItems = [];
    for (const title of titles) {
      const {id, name} = title;
      this.standardTitleItems.push({
        label: title.name,
        value: {id, name}
      });
    }
  }

  change(event) {
    this.onSelect.emit(event);
  }

}
